import gql from 'graphql-tag';

const FRAGMENT = gql`
  fragment ModuleSummary on modules {
    name
    id
    deleted
  }
  fragment ExerciseSummary on exercises {
    id
    name
    description
    duration
    type
    tags  
  }
  fragment StudentMilestone on student_milestones {
    id
    name
    due_date
    status
    order
  }
  fragment StudentMilestoneExercise on student_milestone_exercises {
    id
    due_date
    status
    order
    response
    user_id
    completed_at
    exercise {
      id
      name
      description
      duration
      type
      meeting_type
      tags  
      module {
        id
        name
      }
    }
  }
  fragment StudentMilestonesDetails on student_milestones {
    ...StudentMilestone
    exercises: student_milestone_exercises(
      order_by: [{ order: asc }]
      where: {
        _or: [
          { exercise: { type: { _in: ["worksheet", "snapshot"] } } }
          { exercise: { meeting_type: { _neq: "fa" } } }
        ]
      }
    ) {
      ...StudentMilestoneExercise
    }
  }
`;

export const GET_STUDENT_MILESTONES = gql`
  query getStudentMilestones($userId: Int, $status: String, $limit: Int) {
    milestones: student_milestones(
      where: { user_id: { _eq: $userId }, status: { _eq: $status } }
      order_by: [{ order: asc }]
      limit: $limit  
    ) {
      ...StudentMilestonesDetails
    }
  }
  ${FRAGMENT}
`;

export const GET_STUDENT_NOT_STARTED_MILESTONES = gql`
    query getStudentMilestones($userId: Int, $limit: Int) {
        milestones: student_milestones(
            where: { user_id: { _eq: $userId }, status: { _is_null: true } }
            order_by: [{ order: asc }]
            limit: $limit
        ) {
            ...StudentMilestonesDetails
        }
    }
    ${FRAGMENT}
`;


export const MILESTONE_STATS = gql`
  query getStudentMilestonesStats($userId: Int) {
    milestones_count: student_milestones_aggregate(
      where: { user_id: { _eq: $userId } }
    ) {
      aggregate {
        count
      }
    }
    done_count: student_milestones_aggregate(
      where: { user_id: { _eq: $userId }, status: { _eq: "done" } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_STUDENT_WORKSHEETS = gql`
  query getStudentWorksheets($userId: Int!) {
    modules(
      where: {
        deleted: { _neq: true }
        exercises: {
          type: { _eq: "worksheet" }
          student_milestone_exercises: {
              user_id: { _eq: $userId }
          }  
        }
      }
      order_by: [{ order: asc_nulls_last }]
    ) {
      ...ModuleSummary
      exercises(
        where: { deleted: { _neq: true } }
        order_by: [{ order: asc_nulls_last }]
      ) {
        ...ExerciseSummary
        student_milestone_exercises(where: { user_id: { _eq: $userId } }) {
          id
          status
          due_date
        }
      }
    }
  }
  ${FRAGMENT}
`;

export const GET_MILESTONES_TASKS_BY_STATUS = gql`
  query getStudentMilestones($userId: Int, $status: String!) {
    exercises: student_milestone_exercises(
      where: { user_id: { _eq: $userId }, status: { _eq: $status } }
      order_by: [{ due_date: asc }, { id: asc }]
    ) {
      ...StudentMilestoneExercise
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_MILESTONE = gql`
  mutation updateMilestone($id: Int!, $input: student_milestones_set_input!) {
    update_student_milestones(where: { id: { _eq: $id } }, _set: $input) {
      returning {
        ...StudentMilestone
      }
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_MILESTONE_EXERCISE_AND_STATUS = gql`
  mutation updateExercise(
    $id: Int!
    $input: student_milestone_exercises_set_input!
    $milestoneId: Int
    $data: student_milestones_set_input
  ) {
    update_student_milestone_exercises(
      where: { id: { _eq: $id } }
      _set: $input
    ) {
      returning {
        ...StudentMilestoneExercise
      }
    }
    update_student_milestones(
      where: { id: { _eq: $milestoneId } }
      _set: $data
    ) {
      returning {
        ...StudentMilestone
      }
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_MILESTONE_EXERCISE = gql`
  mutation updateExercise(
    $id: Int!
    $input: student_milestone_exercises_set_input!
    $milestoneId: Int
    $data: student_milestones_set_input
  ) {
    update_student_milestone_exercises(
      where: { id: { _eq: $id } }
      _set: $input
    ) {
      returning {
        ...StudentMilestoneExercise
      }
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_MILESTONE_FAEXERCISE = gql`
  mutation updateExercise(
    $id: Int!
    $input: student_milestone_exercises_set_input!
  ) {
    update_student_milestone_exercises(
      where: { id: { _eq: $id } }
      _set: $input
    ) {
      returning {
        ...StudentMilestoneExercise
      }
    }
  }
  ${FRAGMENT}
`;

export const CANCEL_MILESTONE_MEETING = gql`
  mutation updateExercise(
    $id: Int!
    $input: student_milestone_exercises_set_input!
  ) {
    update_student_milestone_exercises(
      where: { id: { _eq: $id } }
      _set: $input
    ) {
      returning {
        ...StudentMilestoneExercise
      }
    }
  }
  ${FRAGMENT}
`;
